"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEcommCrmFiltersWithStoreToken = exports.ObjectTypes = exports.IntegrationStatusPropType = exports.IntegrationStatuses = exports.SHOPIFY_APP_ID_PROD = exports.SHOPIFY_APP_ID_QA = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var SHOPIFY_APP_ID_QA = 1161155;
exports.SHOPIFY_APP_ID_QA = SHOPIFY_APP_ID_QA;
var SHOPIFY_APP_ID_PROD = 51381;
exports.SHOPIFY_APP_ID_PROD = SHOPIFY_APP_ID_PROD;
var IntegrationStatuses = (0, _keyMirror.default)({
  INTEGRATED: null,
  NOT_INTEGRATED: null,
  WARNING: null,
  ERROR: null
});
exports.IntegrationStatuses = IntegrationStatuses;

var IntegrationStatusPropType = _propTypes.default.oneOf(Object.keys(IntegrationStatuses));

exports.IntegrationStatusPropType = IntegrationStatusPropType;
var ObjectTypes = [{
  key: 'PRODUCT',
  translationKey: 'product'
}, {
  key: 'CONTACT',
  translationKey: 'contact'
}, {
  key: 'DEAL',
  sub: 'LINE_ITEM',
  translationKey: 'deal'
}];
exports.ObjectTypes = ObjectTypes;

var getEcommCrmFiltersWithStoreToken = function getEcommCrmFiltersWithStoreToken(storeToken) {
  return encodeURIComponent(JSON.stringify([{
    operator: 'IN',
    property: 'ip__ecomm_bridge__ecomm_synced',
    values: ['true']
  }, {
    operator: 'IN',
    property: 'ip__ecomm_bridge__source_store_id',
    values: [storeToken]
  }]));
};

exports.getEcommCrmFiltersWithStoreToken = getEcommCrmFiltersWithStoreToken;